import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, PageLoader, Pagination, RevisionHistory, STableLoader, } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus, checkPermission } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import ThrustListing from "../components/ThrustListing";
import AddEditThrust from "../components/AddEditThrust";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const ThrustObj = {
    name: null,
    remarks: null,
}

const ThrustHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell><div style={{ width: '100px' }}>{checkPermission('config_data', 'engine_family', 'D') && <Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</div></TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

const ThrustCategory = ({id}) => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [addEditThrust, setAddEditThrust] = useState({ modal: false, data: null });
    const [deleteThrust, setDeleteThrust] = useState({ modal: false, data: null });
    const [revertThrust, setRevertThrust] = useState({ modal: false, data: null });
    const [thrustInfo, setThrustInfo] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getThrust({ per_page: 50 }, "skeletonLoader");
        trackActivity('Console Management', { page_title: 'Config Data : Engine Family', event_type: 'View Page Visited' })
    }, [])


    const getThrust = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/engine-thrust-category/?engine_family=${id}`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setThrustInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteThrust.data ? Object.values(pageSelections).flat().filter(id => {
            const item = thrustInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteThrust.data.id

        globalDeleteService(`config-data/engine-thrust-category/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteThrust({ modal: false, data: null });
                    getThrust({ ...filter, page: thrustInfo?.pagination?.page, per_page: thrustInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family View',
                        event_type: `Item Deleted`,
                        event_desc: 'Thrust Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteThrust({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family View',
                        event_type: `Item Deleted`,
                        event_desc: 'Thrust Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertThrust.data ? Object.values(pageSelections).flat().filter(id => {
            const item = thrustInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertThrust.data;

        globalPutService(`config-data/engine-thrust-category/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertThrust({ modal: false, data: null });
                    getThrust({ ...filter, page: thrustInfo?.pagination?.page, per_page: thrustInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family View',
                        event_type: `Item Reverted`,
                        event_desc: 'Thrust Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertThrust({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Engine Family View',
                        event_type: `Item Reverted`,
                        event_desc: 'Thrust Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = thrustInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = thrustInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getThrust({ ...filter, ...sortQuery, page: 1, per_page: thrustInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = thrustInfo?.list?.length > 0 && pageSelections[currentPage]?.length === thrustInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertThrust?.modal || bulkRevert?.modal) return "primary";
        if (deleteThrust?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertThrust?.modal || bulkRevert?.modal) return "Revert";
        if (deleteThrust?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertThrust?.modal) return revertThrust.modal;
        if (deleteThrust?.modal) return deleteThrust.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertThrust?.modal) return "Revert Thrust Category";
        if (deleteThrust?.modal) return "Delete Thrust Category";
        if (bulkDelete?.modal) return `Delete Thrust Category (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Thrust Category (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertThrust?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteThrust?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertThrust?.modal) {
            setRevertThrust({ modal: false, data: null });
        } else if (deleteThrust?.modal) {
            setDeleteThrust({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        }
    };


    const getDeleteRecordFn = () => {
        if (revertThrust?.modal || bulkRevert?.modal) return onRevert;
        if (deleteThrust?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

    return (
        <div style={{ paddingTop: '0px' }}>
            {skeletonLoader ? <STableLoader count={6} size={5} /> :
                <div style={{ paddingTop: '10px' }}>
                    <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: "2px" }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item md={6}>
                            </Grid>
                            <Grid item md={6}>
                                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                    {(revertCount > 0 && checkPermission('config_data', 'engine_family', 'RVT')) ? 
                                        <>
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Region` }) }} color="primary" size='small' variant="outlined">
                                                Revert ({revertCount})
                                            </Button>
                                        </li>
                                        </> : null
                                   }
                                    {(deleteCount > 0 && checkPermission('config_data', 'engine_family', 'D')) ? 
                                    <>
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Region', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Region` }) }} color="secondary" size='small' variant="contained">
                                                Delete ({deleteCount})
                                            </Button>
                                        </li>
                                        </> : null
                                    }
                                    {checkPermission('config_data', 'engine_family', 'C') &&  <li className='list-inline-item'>
                                        <Button onClick={() => setAddEditThrust({ modal: true, data: ThrustObj })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                    </li> }
                                    <li className="list-inline-item" style={{ cursor: 'pointer' }}>
                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdenginethrustcategory/`} queryParams={{ action: '0,1,2' }} />
                                    </li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper square>
                      <div style={{ height: `${(window.innerHeight - (thrustInfo?.list?.length ? 495 : 450)) - navTitleOffset}px`, overflow: 'auto' }}>
                        <Table className='mui-table-format' stickyHeader>
                            <ThrustHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                            <TableBody>
                                {thrustInfo?.list?.length > 0 && thrustInfo?.list?.map((item, index) =>
                                    <ThrustListing
                                        item={item}
                                        index={index}
                                        onDelete={setDeleteThrust}
                                        onRevert={setRevertThrust}
                                        onEditFn={() => setAddEditThrust({ modal: true, data: item, type: 'edit' })}
                                        toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                        bulkIds={pageSelections[currentPage] || []}
                                    />
                                )}
                            </TableBody>
                        </Table>
                           {!thrustInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                      </div>
                    </Paper>
                    <Paper square>
                        <Pagination
                            pagination={thrustInfo?.pagination}
                            onChangePage={(event, newPage) => { getThrust({ ...filter, page: newPage + 1, per_page: thrustInfo.pagination?.per_page }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                            onChangeRowsPerPage={(event) => getThrust({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>
                </div>}

            {addEditThrust.modal ?
                <AddEditThrust
                    engine_family_id={id}
                    addEditThrust={addEditThrust}
                    thrustInfo={thrustInfo}
                    toggleModalFn={() => setAddEditThrust({ modal: false, regionData: [] })}
                    getResponseBack={() => getThrust({ ...filter, page: thrustInfo?.pagination?.page, per_page: thrustInfo?.pagination?.per_page }, 'pageLoader')}
                    modeType={addEditThrust?.type}
                /> : null
            }
            <DeletePopUp
                confirmColor={getConfirmColor()}
                confirmText={getConfirmText()}
                modal={getModal()}
                title={getTitle()}
                content={getContent()}
                toggleModalFn={toggleModalFn}
                deleteRecordFn={getDeleteRecordFn()}
            />
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default ThrustCategory;